import { useHandler } from "@suse-o11y/use-handler";
import debounce from "lodash/debounce";
import React from "react";

export function useDebounce<TArgs extends Array<unknown>>(
	callback: (...args: TArgs) => void,
	wait = 500,
): (...args: TArgs) => void {
	const stableCallback = useHandler(callback);
	const debouncedCallback = React.useMemo(() => debounce(stableCallback, wait), [stableCallback, wait]);

	React.useEffect(() => () => debouncedCallback.cancel(), [debouncedCallback]);

	return debouncedCallback;
}
